<p-dialog
  *transloco="let t"
  [header]="isEditMode() ? t('user.management.editUser') : t('user.management.addUser')"
  [(visible)]="visible"
  [style]="{width: '600px'}"
  [modal]="true"
  [closable]="false"
>
  <div class="flex flex-col gap-4 p-4">
    <form [formGroup]="userForm" #formDir="ngForm" class="flex flex-col gap-4">
      <div class="grid grid-cols-2 gap-4">
        <div class="col">
          <app-form-field
            id="firstName"
            fieldName="firstName"
            [placeholder]="t('common.firstName')"
            [label]="t('common.firstName')"
            data-testid="add-user-firstName"
          >
          </app-form-field>
        </div>
        <div class="col">
          <app-form-field
            id="lastName"
            fieldName="lastName"
            [placeholder]="t('common.lastName')"
            [label]="t('common.lastName')"
            data-testid="add-user-lastName"
          >
          </app-form-field>
        </div>
      </div>

      <app-form-field
        id="email"
        fieldName="email"
        [label]="t('common.email')"
        type="email"
        [placeholder]="t('common.email')"
        data-testid="add-user-email"
      >
      </app-form-field>

      <div class="field">
        <label for="role" class="block mb-2">
          {{ t('user.management.role') }}
        </label>
        <p-select
          id="role"
          [options]="roleOptions()"
          formControlName="role"
          optionLabel="translation"
          optionValue="enum"
          [placeholder]="t('user.management.role')"
          class="w-full"
          [appendTo]="'body'"
          [ngClass]="getInvalidClass('role')"
          data-testid="add-user-role"
        >
          <ng-template #item let-opt>
            <div class="flex items-center gap-2">
              {{ opt.translation }}
              <app-directus-tooltip
                [tooltipKey]="'userManagement_roleDescription_' + opt.enum"
              ></app-directus-tooltip>
            </div>
          </ng-template>
        </p-select>
        @if (userForm.get('role')?.invalid && userForm.get('role')?.touched) {
          <p-message
            severity="error"
            variant="simple"
            size="small"
            [attr.data-testid]="'role-required-error'"
          >
            {{ 'account.validation.requiredField' | transloco }}
          </p-message>
        }
      </div>

      @if (isContributorSelected()) {
        <div>
          <p-divider>
            <span class="font-medium">{{ t('user.management.contributor') }}</span>
          </p-divider>
          <div class="field">
            <label for="selectedNodes" class="block mb-2">{{
              t('user.management.accessPages')
            }}</label>
            <p-treeSelect
              id="selectedNodes"
              class="w-full"
              containerStyleClass="w-full"
              formControlName="selectedNodes"
              [options]="pageOptions()"
              display="chip"
              [metaKeySelection]="false"
              selectionMode="checkbox"
              [placeholder]="t('user.management.accessPages')"
              [virtualScroll]="true"
              [virtualScrollItemSize]="46"
              [virtualScrollOptions]="{scrollHeight: '200px'}"
              [appendTo]="'body'"
              [ngClass]="getInvalidClass('selectedNodes')"
              data-testid="add-user-pages"
            >
            </p-treeSelect>
            @if (
              userForm.get('selectedNodes')?.invalid &&
              userForm.get('selectedNodes')?.dirty &&
              userForm.get('selectedNodes')?.touched
            ) {
              <p-message
                severity="error"
                variant="simple"
                size="small"
                [attr.data-testid]="'selectedNodes-required-error'"
              >
                {{ 'account.validation.requiredField' | transloco }}
              </p-message>
            }
          </div>
        </div>
      }
    </form>
  </div>

  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button
        [label]="t('common.cancel')"
        icon="pi pi-times"
        styleClass="p-button-text"
        (onClick)="onCancel()"
        data-testid="add-user-cancel-button"
      >
      </p-button>
      <p-button
        [label]="t('common.save')"
        icon="pi pi-check"
        styleClass="p-button-primary"
        (onClick)="onAdd()"
        [disabled]="userForm.invalid"
        data-testid="add-user-add-button"
      >
      </p-button>
    </div>
  </ng-template>
</p-dialog>
